/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Phone_InvalidInputs */

const en_business_form_phone_invalid = /** @type {(inputs: Business_Form_Phone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please include your country code, e.g. +1 555 123 4567`)
};

const es_business_form_phone_invalid = /** @type {(inputs: Business_Form_Phone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor incluye tu código de país, p. ej. +34 555 123 456`)
};

/**
* | output |
* | --- |
* | "Please include your country code, e.g. +1 555 123 4567" |
*
* @param {Business_Form_Phone_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_phone_invalid = /** @type {((inputs?: Business_Form_Phone_InvalidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Phone_InvalidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_phone_invalid(inputs)
	return en_business_form_phone_invalid(inputs)
});